/**
 * Icone unificate per tipo di consegna — usate ovunque (home, calcolatore,
 * checkout, dettaglio ordine, dashboard) per coerenza visiva.
 *
 * Phase 38 — riferimento "Landing.jsx" (CommuterCard) come fonte di verità.
 */
import { Route, Truck, Zap, Box } from "lucide-react";

export const DELIVERY_TYPE_ICON = {
  shared: Route,
  standard: Truck,
  express: Zap,
  van: Box,
};

export function getDeliveryIcon(id) {
  return DELIVERY_TYPE_ICON[id] || Truck;
}
